"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLastPage = exports.isFirstPage = exports.isErrorOnThePage = exports.getWaitForMetricsSaved = exports.getSkippedElements = exports.getShowBottomBar = exports.getSegmentedProgressBar = exports.getScopedList = exports.getProgressBarPercent = exports.getProgress = exports.getPlayerTemplate = exports.getPagesForPrintMode = exports.getPages = exports.getPagePreloadedAssetsProgress = exports.getPageElements = exports.getPageAssetsToPreload = exports.getPageAssets = exports.getNextPagePreloadedAssetsProgress = exports.getNextPageAssetsToPreload = exports.getNextFirstElementId = exports.getList = exports.getLinks = exports.getLastPageElement = exports.getIsSkipped = exports.getIsPageVisited = exports.getIsMobilePageDescriptionVisible = exports.getIsAudioOnLoad = exports.getHasUnfinishedAjax = exports.getHasPageFeedback = exports.getFutureAssetsToPreload = exports.getFlowStartedFinished = exports.getFinalTestElements = exports.getElementTree = exports.getDirections = exports.getDirectNextElementId = exports.getDataConnectorsVariableIds = exports.getConnectedList = exports.getComposedAccommodations = exports.getBubbleMessages = exports.getAudioReadyState = exports.getAllowScaling = exports.getAllowCancelAudio = exports.getAllQuestionStartNumbers = exports.getAllDirections = exports.getAllDataConnectors = exports.getActualPageFirstElementId = void 0;
var _reselect = require("reselect");
var _last2 = _interopRequireDefault(require("lodash/last"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _min2 = _interopRequireDefault(require("lodash/min"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _flattenDeep2 = _interopRequireDefault(require("lodash/flattenDeep"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _flat = _interopRequireDefault(require("flat"));
var _operators = require("cccisd-survey-common/dist/helpers/BuilderWrapper/ShowConditionsBlock/operators.js");
var _common = require("./common.js");
var _player = _interopRequireWildcard(require("../reducers/player.js"));
var _allTemplates = require("../allTemplates.js");
var _getWysiwygText = _interopRequireDefault(require("cccisd-survey-common/dist/helpers/getWysiwygText.js"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var playerTemplateList = (0, _allTemplates.getTemplateList)('players', 'flow');
var getState = function getState(state) {
  return state;
};
var getIsCompleted = function getIsCompleted(state) {
  return state.isCompleted;
};
var getOriginalList = function getOriginalList(state) {
  return state.list;
};
var getAnswers = function getAnswers(state) {
  return state.answers;
};
var getErrors = function getErrors(state) {
  return state.errors;
};
var getPageFirstElementId = function getPageFirstElementId(state) {
  return state.pageFirstElementId;
};
var getPerPage = function getPerPage(state) {
  return state.settings.showOneElementPerPage ? 1 : 9999;
};
var getSettings = function getSettings(state) {
  return state.settings;
};
var getPlayingParentId = function getPlayingParentId(state) {
  return state.playingParentId;
};
var getAccommodations = function getAccommodations(state) {
  return state.accommodations;
};
var getAllElements = function getAllElements(state) {
  return state.allElements;
};
var getAllProgress = function getAllProgress(state) {
  return state.progress;
};
var getIsAudioReady = function getIsAudioReady(state) {
  return state.isAudioReady;
};
var getAjax = function getAjax(state) {
  return state.ajax;
};
var getPreloadedAssets = function getPreloadedAssets(state) {
  return state.preloadedAssets;
};
var getElementsNumberToPreloadAssets = function getElementsNumberToPreloadAssets(state) {
  return state.elementsNumberToPreloadAssets;
};
var getDynamicDataValues = function getDynamicDataValues(state) {
  return state.dynamicDataValues;
};
var getMetricsValues = function getMetricsValues(state) {
  return state.metricsValues;
};
var getList = (0, _reselect.createSelector)(getOriginalList, function (list) {
  var result = _objectSpread({}, list);
  for (var _i = 0, _Object$entries = Object.entries(result); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (value.settings && value.settings.showConditionsRules) {
      if (Array.isArray(value.settings.showConditionsRules) && value.settings.showConditionsRules.length === 0) {
        result[key] = _objectSpread(_objectSpread({}, value), {}, {
          settings: _objectSpread(_objectSpread({}, value.settings), {}, {
            showConditionsRules: null
          })
        });
      } else if (!value.settings.showConditionsRules.aggregation) {
        result[key] = _objectSpread(_objectSpread({}, value), {}, {
          settings: _objectSpread(_objectSpread({}, value.settings), {}, {
            showConditionsRules: {
              aggregation: 'all',
              conditions: value.settings.showConditionsRules
            }
          })
        });
      }
    }
  }
  return result;
});
exports.getList = getList;
var getConnectedList = (0, _reselect.createSelector)(getList, getAnswers, getAllElements, getDynamicDataValues, getMetricsValues, getSettings, function (list, answers, allElements, dynamicDataValues, metricsValues, settings) {
  var defaultData = {
    array: [],
    collection: []
  };
  var getData = function getData(item) {
    try {
      // For app variables
      if (item.category === 'dynamic') {
        if (!dynamicDataValues[item.name]) {
          throw new Error("No app variable with handle=\"".concat(item.name, "\""));
        }
        return dynamicDataValues[item.name];
      }

      // For metrics
      if (item.category === 'metrics') {
        if (!metricsValues[item.id]) {
          throw new Error("No metric with id=\"".concat(item.id, "\""));
        }
        return metricsValues[item.id];
      }
      var element = list[item.id];
      if (!element) {
        throw new Error("No element with id=".concat(item.id));
      }
      var elementType = (0, _find2["default"])(allElements, {
        code: element.type
      });
      if (!elementType) {
        throw new Error("No element type \"".concat(element.type, "\""));
      }
      if (!elementType.getDataConnectorsValues) {
        throw new Error('No data connectors values function');
      }
      var dataConnector = elementType.getDataConnectorsValues(processItem(element.settings), processItem(answers[item.id]), settings === null || settings === void 0 ? void 0 : settings.language);
      if (!dataConnector[item.name]) {
        throw new Error("No data connector with the name \"".concat(item.name, "\""));
      }
      return dataConnector[item.name]();
    } catch (e) {
      var defaultValue = defaultData[item.type] || null;
      console.warn(e + '. Using default value.');
      return defaultValue;
    }
  };
  var setHiddenState = function setHiddenState(element) {
    var hidden = false;
    var isShow = function isShow(item, path) {
      if (!item) {
        return true;
      }
      if (item.aggregation === 'all') {
        return item.conditions.every(function (val, index) {
          return isShow(val, path + ".conditions[".concat(index, "]"));
        });
      }
      if (item.aggregation === 'any') {
        return item.conditions.some(function (val, index) {
          return isShow(val, path + ".conditions[".concat(index, "]"));
        });
      }
      var dataConnector = item.dataConnector,
        operator = item.operator,
        value = item.value;

      // Get dataConnectorType from original list
      // because in element all dataConnectors are replaced with values
      var totalPath = "".concat(element.id, ".settings.showConditionsRules").concat(path, ".dataConnector.type");
      var dataConnectorType = (0, _get2["default"])(list, totalPath);
      return (0, _operators.evaluateCondition)({
        dataConnector: dataConnector,
        type: dataConnectorType,
        operator: operator,
        value: value
      });
    };
    if (element.settings && element.settings.showConditionsRules) {
      hidden = !isShow(element.settings.showConditionsRules, '');
    }
    if (hidden) {
      return _objectSpread(_objectSpread({}, element), {}, {
        hiddenByConditions: true
      });
    }
    return element;
  };
  var processItem = function processItem(item) {
    if (!(0, _isPlainObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return item;
    }
    if ((0, _isPlainObject2["default"])(item) && item.instance === 'dataConnector') {
      return getData(item);
    }
    if ((0, _isPlainObject2["default"])(item)) {
      return (0, _mapValues2["default"])(item, function (child) {
        return processItem(child);
      });
    }
    return (0, _map2["default"])(item, function (child) {
      return processItem(child);
    });
  };
  var result = processItem(list);
  result = (0, _mapValues2["default"])(result, setHiddenState);
  return result;
});
exports.getConnectedList = getConnectedList;
var getScopedList = (0, _reselect.createSelector)(getConnectedList, getPlayingParentId, function (list, playingParentId) {
  if (!playingParentId || playingParentId === 0) {
    return list;
  }
  if (!list[playingParentId]) {
    throw new Error("There is no parent with id=".concat(playingParentId));
  }
  if (!list[playingParentId].children) {
    throw new Error("Parent with id=".concat(playingParentId, " is not an adult"));
  }
  var keys = [];
  function getChildren(id) {
    keys.push(id);
    if (list[id].children) {
      list[id].children.map(function (childId) {
        return getChildren(childId);
      });
    }
  }
  list[playingParentId].children.map(function (childId) {
    return getChildren(childId);
  });
  var result = (0, _pick2["default"])(list, keys);
  result[0] = _objectSpread(_objectSpread({}, list[playingParentId]), {}, {
    id: 0
  });
  return result;
});
exports.getScopedList = getScopedList;
var getLinks = (0, _reselect.createSelector)(getScopedList, function (list) {
  var result = {};
  var prevId = null;
  var count = 1;
  var pageBreakBefore = false;
  function getChildren(id) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var siblings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    result[id] = _objectSpread(_objectSpread({}, list[id]), {}, {
      count: count,
      parents: parents,
      siblings: siblings,
      prevId: prevId
    });
    if (pageBreakBefore) {
      result[id].pageBreakBefore = true;
      pageBreakBefore = false;
    }
    if (prevId) {
      result[prevId].nextId = id;
    }
    prevId = id;
    if (list[id].type !== 'pageBreak' && !list[id].children) {
      count++;
    }
    if (list[id].children) {
      list[id].children.map(function (childId) {
        return getChildren(childId, [id].concat(_toConsumableArray(parents)), list[id].children);
      });
    }

    // Put page break if block with blockIsSeparatePage=true
    if (list[id].children && list[id].settings && list[id].settings.blockIsSeparatePage) {
      result[id].pageBreakBefore = true;
      pageBreakBefore = true;
    }
  }
  if (!list[0]) {
    return {};
  }
  result[0] = _objectSpread({}, list[0]);
  list[0].children.map(function (childId) {
    return getChildren(childId, [0], list[0].children);
  });
  if (prevId) {
    result[prevId].nextId = null;
  }

  // Get all children
  function getAllChildren(id) {
    var element = list[id];
    if (!element.children) {
      return [];
    }
    var array = (0, _flattenDeep2["default"])([element.children, element.children.map(function (child) {
      return getAllChildren(child);
    })]);
    result[id].allChildren = array;
    return array;
  }
  getAllChildren(0);
  return result;
});
exports.getLinks = getLinks;
var getActualPageFirstElementId = (0, _reselect.createSelector)(getLinks, getPageFirstElementId, function (links, pageFirstElementId) {
  var getFirstComponentId = function getFirstComponentId(prevId) {
    if (!links[prevId].skipPlaying && !links[prevId].hiddenByConditions && (links[prevId].type === 'menu' || !links[prevId].children)) {
      return prevId;
    }
    return links[prevId].nextId ? getFirstComponentId(links[prevId].nextId) : 0;
  };
  var id = pageFirstElementId;
  if (id === 0 || !links[id]) {
    if (!links[0] || !links[0].children[0]) {
      return 0;
    }
    id = links[0].children[0];
  }
  return getFirstComponentId(id);
});
exports.getActualPageFirstElementId = getActualPageFirstElementId;
var getDirections = (0, _reselect.createSelector)(getScopedList, getAllElements, getAnswers, function (list, allElements, answers) {
  var result = [];
  var handleElement = function handleElement(id) {
    var item = list[id];
    if (!item) {
      return;
    }
    if (id !== 0) {
      result.push({
        id: id,
        direction: 'in'
      });
    }
    if (item.children && !item.hiddenByConditions) {
      var children = item.children;
      var elementType = (0, _find2["default"])(allElements, {
        code: item.type
      });
      if (elementType && elementType.selectChildren) {
        var selectedChildren = (0, _get2["default"])(answers, "".concat(item.id, ".selectedChildren"));
        if (Array.isArray(selectedChildren)) {
          children = selectedChildren.filter(function (childId) {
            return children.includes(childId);
          });
        }
      }
      children.forEach(handleElement);
    }
    if (id !== 0) {
      result.push({
        id: id,
        direction: 'out'
      });
    }
  };
  handleElement(0);
  return result;
});
exports.getDirections = getDirections;
var getAllDirections = (0, _reselect.createSelector)(getScopedList, function (list) {
  var result = [];
  var handleElement = function handleElement(id) {
    var item = list[id];
    if (!item) {
      return;
    }
    if (id !== 0) {
      result.push({
        id: id,
        direction: 'in'
      });
    }
    if (item && item.children) {
      item.children.forEach(handleElement);
    }
    if (id !== 0) {
      result.push({
        id: id,
        direction: 'out'
      });
    }
  };
  handleElement(0);
  return result;
});
exports.getAllDirections = getAllDirections;
var getPageElements = (0, _reselect.createSelector)(getScopedList, getPageFirstElementId, getPerPage, getLinks, getDirections, function (list, pageFirstElementId, perPage, links, directions) {
  var id = pageFirstElementId;
  if (id === 0 || !list[id]) {
    if (!list[0]) {
      return [];
    }
    id = list[0].children[0];
  }
  if (!id) {
    return [];
  }
  var result = [];
  var index = (0, _findIndex2["default"])(directions, {
    id: id,
    direction: 'in'
  });
  if (index === -1) {
    return result;
  }
  var count = 0;
  for (var i = index; i < directions.length; i++) {
    var direction = directions[i];
    var element = list[direction.id];
    var link = links[direction.id];
    if (element.type === 'pageBreak' && count === 0) {
      continue;
    } else if (element.type === 'pageBreak' || count >= perPage) {
      break;
    } else if (direction.direction === 'in' && link.pageBreakBefore && count > 0) {
      break;
    } else if (direction.direction === 'out') {
      if (element.children) {
        var parentLink = links[link.parents[0]];
        if (!parentLink.skipPlaying && parentLink.returnControlAfterChildren) {
          break;
        }
      }
      continue;
    } else if (element.skipPlaying || element.hiddenByConditions) {
      continue;
    } else if (element.isAloneOnThePage || (0, _get2["default"])(element, 'settings.isAdjustedPlayerSettings')) {
      if (count === 0) {
        result.push(element);
      }
      break;
    }
    count++;
    result.push(element);
  }
  return result;
});
exports.getPageElements = getPageElements;
var getFinalTestElements = (0, _reselect.createSelector)(getScopedList, getDirections, getAnswers, function (list, directions, answers) {
  var result = [];
  var _iterator = _createForOfIteratorHelper(directions),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var direction = _step.value;
      if (direction.direction !== 'in') {
        continue;
      }
      var element = list[direction.id];
      if (element.settings && element.settings.hasCorrectAnswers && answers[element.id]) {
        result.push(element);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
});
exports.getFinalTestElements = getFinalTestElements;
var getProgressBarPercent = (0, _reselect.createSelector)(getScopedList, getPageElements, getDirections, function (list, pageElements, directions) {
  var realElements = directions.filter(function (dir) {
    if (dir.direction !== 'in') {
      return false;
    }
    var element = list[dir.id];
    return element && element.type !== 'pageBreak' && !element.children;
  });
  if (realElements.length === 0) {
    return 0;
  }
  if (pageElements.length === 0) {
    return 100;
  }
  var lastElement = (0, _last2["default"])(pageElements);
  var lastElementIndex = realElements.findIndex(function (dir) {
    return dir.id === lastElement.id;
  });
  if (lastElementIndex === -1) {
    return 100;
  }
  var value = Math.round((lastElementIndex + 1) / realElements.length * 100);
  return Math.max(Math.min(value, 100), 0);
});
exports.getProgressBarPercent = getProgressBarPercent;
var getPages = (0, _reselect.createSelector)(getScopedList, getPageFirstElementId, getPerPage, getLinks, function (list, pageFirstElementId, perPage, links) {
  var result = [];
  if (!list[0] || list[0].children.length === 0) {
    return [];
  }
  if (pageFirstElementId === 0 || !list[pageFirstElementId]) {
    pageFirstElementId = list[0].children[0];
  }
  var count = 0;
  var id = list[0].children[0];
  var page = {
    state: 'prev',
    firstElementId: 0
  };
  while (id) {
    var link = links[id];
    if (page.firstElementId === 0 && link.type !== 'pageBreak') {
      page.firstElementId = id;
    }
    if (id === pageFirstElementId) {
      page = _objectSpread(_objectSpread({}, page), {}, {
        state: 'current'
      });
    }
    if (link.pageBreakBefore && count > 0) {
      result.push(page);
      count = 0;
      page = _objectSpread(_objectSpread({}, page), {}, {
        firstElementId: 0
      });
      if (page.state === 'current') {
        page.state = 'next';
      }
      continue;
    }
    if (link.type === 'pageBreak' && count === 0 || link.children) {
      id = link.nextId;
      continue;
    } else if (link.type === 'pageBreak' || count >= perPage - 1) {
      result.push(page);
      count = 0;
      page = _objectSpread(_objectSpread({}, page), {}, {
        firstElementId: 0
      });
      if (page.state === 'current') {
        page.state = 'next';
      }
      id = link.nextId;
      continue;
    }
    count++;
    id = link.nextId;
  }
  if (count > 0) {
    result.push(page);
  }
  return result;
});
exports.getPages = getPages;
var isFirstPage = (0, _reselect.createSelector)(getLinks, getPageFirstElementId, function (links, pageFirstElementId) {
  if (pageFirstElementId === 0) {
    return true;
  }
  var link = links[pageFirstElementId];
  if (!link) {
    return true;
  }
  return link.count === 1;
});
exports.isFirstPage = isFirstPage;
var getLastPageElement = (0, _reselect.createSelector)(getPageElements, getLinks, getPageFirstElementId, function (pageElements, links, actualPageFirstElementId) {
  return (0, _last2["default"])(pageElements) || links[actualPageFirstElementId];
});
exports.getLastPageElement = getLastPageElement;
var getNextFirstElementId = (0, _reselect.createSelector)(getDirections, getPageElements, getLinks, getLastPageElement, function (directions, pageElements, links, lastPageElement) {
  if (!lastPageElement) {
    return null;
  }
  var index = (0, _findIndex2["default"])(directions, {
    id: lastPageElement.id,
    direction: 'out'
  });
  if (index === -1) {
    return null;
  }
  var nextElement;
  for (var i = index + 1; i < directions.length; i++) {
    var direction = directions[i];
    var link = links[direction.id];
    if (!link.skipPlaying && !link.hiddenByConditions) {
      nextElement = link;
      break;
    }
    if (link.children && direction.direction === 'out') {
      var parentLink = links[link.parents[0]];
      if (!parentLink.skipPlaying && parentLink.returnControlAfterChildren) {
        nextElement = parentLink;
        break;
      }
    }
  }
  return nextElement ? nextElement.id : null;
});
exports.getNextFirstElementId = getNextFirstElementId;
var getDirectNextElementId = (0, _reselect.createSelector)(getAllDirections, getPageElements, getLinks, getLastPageElement, function (directions, pageElements, links, lastPageElement) {
  if (!lastPageElement) {
    return null;
  }
  var index = (0, _findIndex2["default"])(directions, {
    id: lastPageElement.id,
    direction: 'out'
  });
  if (index === -1) {
    return null;
  }
  var nextElement;
  for (var i = index + 1; i < directions.length; i++) {
    var direction = directions[i];
    var link = links[direction.id];
    if (direction.direction === 'in') {
      nextElement = link;
      break;
    }
    if (direction.direction === 'out' && link.children) {
      var parentLink = links[link.parents[0]];
      if (!parentLink.skipPlaying && parentLink.returnControlAfterChildren) {
        nextElement = parentLink;
        break;
      }
    }
  }
  return nextElement ? nextElement.id : null;
});
exports.getDirectNextElementId = getDirectNextElementId;
var isLastPage = (0, _reselect.createSelector)(getNextFirstElementId, function (nextFirstElementId) {
  return !nextFirstElementId;
});
exports.isLastPage = isLastPage;
var isErrorOnThePage = (0, _reselect.createSelector)(getPageElements, getErrors, function (pageElements, errors) {
  var result = false;
  (0, _forEach2["default"])(pageElements, function (element) {
    if (errors[element.id]) {
      result = true;
    }
  });
  return result;
});
exports.isErrorOnThePage = isErrorOnThePage;
var getPlayerTemplate = (0, _reselect.createSelector)(getPageElements, getLinks, getSettings, function (pageElements, links, settings) {
  var pageFirstElementId = pageElements.length > 0 ? pageElements[0].id : 0;
  var currentLink = links[pageFirstElementId];
  if (!currentLink) {
    return {};
  }
  function findTemplate(id) {
    var adjustedPlayerSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (id === 0) {
      if (settings.playerTemplate === '') {
        return {};
      }
      return {
        playerTemplate: settings.playerTemplate,
        playerTemplateSettings: (0, _merge2["default"])({}, settings.playerTemplateSettings, adjustedPlayerSettings),
        parentId: id
      };
    }
    var link = links[id];
    if (link.children && link.settings.blockPlayerTemplate && link.settings.blockPlayerTemplate !== '') {
      return {
        playerTemplate: link.settings.blockPlayerTemplate,
        playerTemplateSettings: (0, _merge2["default"])({}, link.settings.blockPlayerTemplateSettings, adjustedPlayerSettings),
        parentId: id
      };
    }
    if (link.children && link.settings.isAdjustedPlayerSettings) {
      adjustedPlayerSettings = (0, _merge2["default"])({}, link.settings.adjustedPlayerSettings, adjustedPlayerSettings);
    }
    return findTemplate(link.parents[0], adjustedPlayerSettings);
  }
  var result = findTemplate(pageFirstElementId);
  if (result.playerTemplate) {
    var playerTemplate = playerTemplateList.find(function (item) {
      return item.name === result.playerTemplate;
    });
    if (!playerTemplate) {
      return {};
    }
    result.playerTemplateSettings = _objectSpread({}, result.playerTemplateSettings);
    if (currentLink.settings && currentLink.settings.isAdjustedPlayerSettings) {
      (0, _merge2["default"])(result.playerTemplateSettings, currentLink.settings.adjustedPlayerSettings);
    }
  }
  return result;
});
exports.getPlayerTemplate = getPlayerTemplate;
var getElementTree = (0, _reselect.createSelector)(getScopedList, function (list) {
  function getChildren(elementId) {
    var element = list[elementId];
    if (!element) {
      return {};
    }
    var result = (0, _omit2["default"])(element, 'children');
    if (element.children) {
      result.children = element.children.map(function (id) {
        return getChildren(id);
      });
    }
    return result;
  }
  return getChildren(0);
});
exports.getElementTree = getElementTree;
var getComposedAccommodations = (0, _reselect.createSelector)(getAccommodations, getSettings, function (appAccommodations, settings) {
  if (!settings.overrideAccommodations) {
    return appAccommodations;
  }
  return settings.accommodations;
});
exports.getComposedAccommodations = getComposedAccommodations;
var getProgress = (0, _reselect.createSelector)(getList, getLinks, getDirections, getPageFirstElementId, getPerPage, getAllProgress, function (list, links, directions, pageFirstElementId, perPage, allProgress) {
  var id = pageFirstElementId;
  if (id === 0 || !list[id]) {
    if (!list[0]) {
      return [];
    }
    id = list[0].children[0];
  }
  if (!id) {
    return [];
  }
  var result = [];
  var index = (0, _findIndex2["default"])(directions, {
    id: id,
    direction: 'in'
  });
  if (index === -1) {
    return result;
  }
  var count = 0;
  var addProgress = function addProgress(direction, element) {
    var progress = direction.direction === 'in' ? 'started' : 'finished';
    result.push({
      id: element.id,
      progress: progress
    });
  };
  var foundPageBreak = false;
  for (var i = index; i < directions.length; i++) {
    var direction = directions[i];
    var element = list[direction.id];
    var link = links[direction.id];
    if (element.isAloneOnThePage || (0, _get2["default"])(element, 'settings.isAdjustedPlayerSettings')) {
      perPage = 1;
    }
    if (foundPageBreak && element.type !== 'pageBreak' && direction.direction === 'in') {
      break;
    } else if (link.hiddenByConditions) {
      continue;
    } else if (element.type === 'pageBreak' && count === 0) {
      continue;
    } else if (element.type === 'pageBreak') {
      foundPageBreak = true;
      continue;
    } else if (link.pageBreakBefore && count > 0 && direction.direction === 'in') {
      break;
    } else if (direction.direction === 'out') {
      addProgress(direction, element);
      var parentLink = links[link.parents[0]];
      if (!parentLink.skipPlaying && parentLink.returnControlAfterChildren) {
        // Mark as finished if all children are finished
        if (parentLink.children.every(function (childId) {
          var _allProgress$childId;
          if (allProgress && (_allProgress$childId = allProgress[childId]) !== null && _allProgress$childId !== void 0 && _allProgress$childId.finishedFirst) {
            return true;
          }
          if (result.find(function (item) {
            return item.id === childId && item.progress === 'finished';
          })) {
            return true;
          }
          return false;
        })) {
          continue;
        }
        break;
      }
      continue;
    } else if (count >= perPage) {
      break;
    } else if (element.skipPlaying) {
      addProgress(direction, element);
      continue;
    }
    addProgress(direction, element);
    count++;
  }
  return result;
});
exports.getProgress = getProgress;
var getAllDataConnectors = (0, _reselect.createSelector)(getList, function (list) {
  var result = [];
  var processItem = function processItem(item) {
    if (!(0, _isPlainObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return;
    }
    if ((0, _isPlainObject2["default"])(item) && item.instance === 'dataConnector') {
      result.push(item);
      return;
    }
    (0, _forEach2["default"])(item, function (child) {
      return processItem(child);
    });
  };
  processItem(list);
  return result;
});
exports.getAllDataConnectors = getAllDataConnectors;
var getDataConnectorsVariableIds = (0, _reselect.createSelector)(getAllDataConnectors, function (allDataConnectors) {
  var ids = allDataConnectors.filter(function (item) {
    return item.category === 'metrics';
  }).map(function (item) {
    return item.id;
  });
  return (0, _uniq2["default"])(ids);
});
exports.getDataConnectorsVariableIds = getDataConnectorsVariableIds;
var getFlowStartedFinished = (0, _reselect.createSelector)(getAllProgress, getIsCompleted, function (progress, isCompleted) {
  var result = {};
  var startedArray = (0, _map2["default"])(progress, function (item) {
    return item.startedFirst;
  });
  if (startedArray.length > 0) {
    result.started = (0, _min2["default"])(startedArray);
  }
  if (isCompleted) {
    // Getting the max of first finished date
    var finishedArray = (0, _map2["default"])(progress, function (item) {
      return item.finishedFirst;
    });
    if (finishedArray.length > 0) {
      result.finished = (0, _max2["default"])(finishedArray);
    }
  }
  return result;
});
exports.getFlowStartedFinished = getFlowStartedFinished;
var getAudioReadyState = (0, _reselect.createSelector)(getIsAudioReady, getList, function (isAudioReady, list) {
  if (isAudioReady) {
    return true;
  }
  var keys = Object.keys((0, _flat["default"])(list));
  return !keys.find(function (key) {
    return key.includes('meta.audio');
  });
});
exports.getAudioReadyState = getAudioReadyState;
var getAllQuestionStartNumbers = (0, _reselect.createSelector)(getList, getAllElements, _common.getAllQuestionStartNumbersHelper);
exports.getAllQuestionStartNumbers = getAllQuestionStartNumbers;
var getHasUnfinishedAjax = (0, _reselect.createSelector)(getAjax, function (ajax) {
  return ajax.length > 0;
});
exports.getHasUnfinishedAjax = getHasUnfinishedAjax;
var getPageAssets = (0, _reselect.createSelector)(getPageElements, getPlayerTemplate, function (elements, playerTemplate) {
  var assets = [];
  var getAssets = function getAssets(item, key, collection) {
    if (!(0, _isObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return;
    }

    // This block can be removed when we have isAsset=true everywhere
    if ((0, _isObject2["default"])(item) && item.meta && item.meta.audio) {
      assets.push(item.meta.audio.url);
    }
    if ((0, _isObject2["default"])(item) && item.isAsset && item.url) {
      assets.push(item.url);
    }
    (0, _forEach2["default"])(item, getAssets);
  };
  getAssets(elements);

  // Get assets from player template
  if (playerTemplate && playerTemplate.playerTemplate) {
    var template = (0, _allTemplates.getTemplate)('players', 'flow', playerTemplate.playerTemplate);
    if (template && template.getAssetsToPreload) {
      var templateSettings = playerTemplate.playerTemplateSettings || {};
      assets.push.apply(assets, _toConsumableArray(template.getAssetsToPreload({
        templateSettings: templateSettings
      })));
    }
  }

  // Get assets from components templates
  elements.filter(function (element) {
    return element.settings && element.settings.template;
  }).forEach(function (element) {
    var template = (0, _allTemplates.getTemplate)('components', element.type, element.settings.template);
    if (template && template.getAssetsToPreload) {
      var _templateSettings = element.settings.templateSettings || {};
      assets.push.apply(assets, _toConsumableArray(template.getAssetsToPreload({
        templateSettings: _templateSettings
      })));
    }
  });
  return (0, _uniq2["default"])(assets.filter(function (asset) {
    return asset && !/^data:/.test(asset);
  }));
});
exports.getPageAssets = getPageAssets;
var getPageAssetsToPreload = (0, _reselect.createSelector)(getPageAssets, getPreloadedAssets, function (pageAssets, preloadedAssets) {
  var preloadedUrls = preloadedAssets.map(function (asset) {
    return asset.url;
  });
  return pageAssets.filter(function (url) {
    return !preloadedUrls.includes(url);
  });
});
exports.getPageAssetsToPreload = getPageAssetsToPreload;
var getPagePreloadedAssetsProgress = (0, _reselect.createSelector)(getPageAssets, getPreloadedAssets, function (assets, preloadedAssets) {
  var total = assets.length * 100;
  var actual = preloadedAssets.filter(function (item) {
    return assets.includes(item.url);
  }).reduce(function (result, item) {
    return item.status === 'done' ? result + 100 : result + Math.min(item.progress, 99);
  }, 0);
  return total === 0 ? 100 : actual / total * 100;
});
exports.getPagePreloadedAssetsProgress = getPagePreloadedAssetsProgress;
var getNextPageAssetsToPreload = (0, _reselect.createSelector)(getState, function (state) {
  var nextState = (0, _player["default"])(state, (0, _player.goToNextPage)());
  return getPageAssetsToPreload(nextState);
});
exports.getNextPageAssetsToPreload = getNextPageAssetsToPreload;
var getNextPagePreloadedAssetsProgress = (0, _reselect.createSelector)(getState, function (state) {
  var nextState = (0, _player["default"])(state, (0, _player.goToNextPage)());
  return getPagePreloadedAssetsProgress(nextState);
});

// we are checking next elements on the page
// and if they have metrics dataConnectors or any visibility condition
// then we have to wait for metrics saved
exports.getNextPagePreloadedAssetsProgress = getNextPagePreloadedAssetsProgress;
var getWaitForMetricsSaved = (0, _reselect.createSelector)(getDirectNextElementId, getList, getLinks, getPerPage, getAllDirections, getAllElements, function (nextElementId, list, links, perPage, directions, allElements) {
  var waitingElements = allElements.filter(function (element) {
    return element.waitForMetricsSaved;
  }).map(function (element) {
    return element.code;
  });
  var hasMetricsDataConnectors = function hasMetricsDataConnectors(item) {
    if (item && item.instance === 'dataConnector' && item.category === 'metrics') {
      return true;
    }
    if (Array.isArray(item)) {
      return item.some(hasMetricsDataConnectors);
    }
    if (_typeof(item) === 'object' && item !== null) {
      return Object.values(item).some(hasMetricsDataConnectors);
    }
    return false;
  };
  var id = nextElementId;
  if (id === 0 || !list[id]) {
    if (!list[0]) {
      return false;
    }
    id = list[0].children[0];
  }
  if (!id) {
    return false;
  }
  var index = (0, _findIndex2["default"])(directions, {
    id: id,
    direction: 'in'
  });
  if (index === -1) {
    return false;
  }
  var count = 0;
  for (var i = index; i < directions.length; i++) {
    var direction = directions[i];
    var element = list[direction.id];
    var link = links[direction.id];
    if (element.type === 'pageBreak' && count === 0) {
      continue;
    } else if (element.type === 'pageBreak' || count >= perPage) {
      break;
    } else if (direction.direction === 'in' && link.pageBreakBefore && count > 0) {
      break;
    } else if (direction.direction === 'out') {
      if (element.children) {
        var parentLink = links[link.parents[0]];
        if (!parentLink.skipPlaying && parentLink.returnControlAfterChildren) {
          break;
        }
      }
      continue;
    } else if (element.settings && element.settings.showConditionsRules || waitingElements.includes(element.type) || hasMetricsDataConnectors(element)) {
      return true;
    } else if (element.skipPlaying) {
      continue;
    } else if (element.isAloneOnThePage || (0, _get2["default"])(element, 'settings.isAdjustedPlayerSettings')) {
      return false;
    }
    count++;
  }
  return false;
});
exports.getWaitForMetricsSaved = getWaitForMetricsSaved;
var getFutureAssetsToPreload = (0, _reselect.createSelector)(getScopedList, getPageFirstElementId, getPreloadedAssets, getDirections, getElementsNumberToPreloadAssets, function (list, pageFirstElementId, preloadedAssets, directions, number) {
  var id = pageFirstElementId;
  if (id === 0 || !list[id]) {
    if (!list[0]) {
      return [];
    }
    id = list[0].children[0];
  }
  if (!id) {
    return [];
  }
  var index = (0, _findIndex2["default"])(directions, {
    id: id,
    direction: 'in'
  });
  if (index === -1) {
    return [];
  }

  // Get elements
  var elements = directions.slice(index).filter(function (item) {
    return item.direction === 'in';
  }).slice(0, number).map(function (item) {
    return list[item.id];
  });

  // Get assets
  var assets = [];
  var getAssets = function getAssets(item, key, collection) {
    if (!(0, _isObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return;
    }
    if ((0, _isObject2["default"])(item) && item.meta && item.meta.audio) {
      assets.push(item.meta.audio.url);
    }
    if ((0, _isObject2["default"])(item) && item.isAsset && item.url) {
      assets.push(item.url);
    }
    (0, _forEach2["default"])(item, getAssets);
  };
  getAssets(elements);

  // Get assets from player templates
  elements.filter(function (element) {
    return element.settings && element.settings.blockPlayerTemplate;
  }).forEach(function (element) {
    var template = (0, _allTemplates.getTemplate)('players', 'flow', element.settings.blockPlayerTemplate);
    if (template && template.getAssetsToPreload) {
      var templateSettings = element.settings.blockPlayerTemplateSettings || {};
      assets.push.apply(assets, _toConsumableArray(template.getAssetsToPreload({
        templateSettings: templateSettings
      })));
    }
  });

  // Get assets from components templates
  elements.filter(function (element) {
    return element.settings && element.settings.template;
  }).forEach(function (element) {
    var template = (0, _allTemplates.getTemplate)('components', element.type, element.settings.template);
    if (template && template.getAssetsToPreload) {
      var templateSettings = element.settings.templateSettings || {};
      assets.push.apply(assets, _toConsumableArray(template.getAssetsToPreload({
        templateSettings: templateSettings
      })));
    }
  });

  // Filter assets
  var preloadedUrls = preloadedAssets.map(function (asset) {
    return asset.url;
  });
  var filteredAssets = (0, _uniq2["default"])(assets).filter(function (url) {
    return url && !preloadedUrls.includes(url) && !/^data:/.test(url);
  });
  return filteredAssets;
});
exports.getFutureAssetsToPreload = getFutureAssetsToPreload;
var getBubbleMessages = (0, _reselect.createSelector)(getPageElements, function (pageElements) {
  return pageElements.reduce(function (array, element) {
    return element.settings && element.settings.bubbleMessages ? [].concat(_toConsumableArray(array), _toConsumableArray(element.settings.bubbleMessages)) : array;
  }, []);
});
exports.getBubbleMessages = getBubbleMessages;
var getPagesForPrintMode = (0, _reselect.createSelector)(getScopedList, getPerPage, getLinks, getDirections, function (list, perPage, links, directions) {
  if (directions.length === 0) {
    return [];
  }
  var pages = [];
  var result = [];
  var count = 0;
  var addPage = function addPage() {
    if (result.length > 0) {
      pages.push(result);
    }
    count = 0;
    result = [];
  };
  for (var i = 0; i < directions.length; i++) {
    var direction = directions[i];
    var element = list[direction.id];
    var link = links[direction.id];
    if (element.type === 'pageBreak' && count === 0) {
      continue;
    } else if (element.settings && element.settings.printSkip) {
      continue;
    } else if (element.type === 'pageBreak' || count >= perPage) {
      addPage();
      continue;
    } else if (direction.direction === 'in' && link.pageBreakBefore && count > 0) {
      addPage();
      continue;
    } else if (direction.direction === 'out') {
      if (element.children) {
        var parentLink = links[link.parents[0]];
        if (!parentLink.skipPlaying && parentLink.returnControlAfterChildren) {
          addPage();
          continue;
        }
      }
      continue;
    } else if (element.skipPlaying || element.hiddenByConditions) {
      continue;
    } else if (element.isAloneOnThePage || (0, _get2["default"])(element, 'settings.isAdjustedPlayerSettings')) {
      if (count === 0) {
        result.push(element);
      }
      addPage();
      continue;
    }
    count++;
    result.push(element);
  }
  if (result.length > 0) {
    pages.push(result);
  }
  return pages;
});
exports.getPagesForPrintMode = getPagesForPrintMode;
var getHasPageFeedback = (0, _reselect.createSelector)(getAllElements, getPageElements, getAnswers, function (allElements, elements, answers) {
  return elements.some(function (item) {
    if (!item.settings) {
      return false;
    }
    if (!item.settings.showAnswerFeedback && !item.settings.showCorrectnessFeedback) {
      return false;
    }
    if (allElements) {
      var elementType = allElements.find(function (element) {
        return element.code === item.type;
      });
      if (elementType && elementType.hasFeedback) {
        return elementType.hasFeedback({
          settings: item.settings,
          answer: answers[item.id]
        });
      }
    }
    return true;
  });
});
exports.getHasPageFeedback = getHasPageFeedback;
var getIsAudioOnLoad = (0, _reselect.createSelector)(getAllElements, getPageElements, function (allElements, pageElements) {
  return pageElements.some(function (element) {
    var typeElement = allElements.find(function (item) {
      return item.code === element.type;
    });
    if (typeElement && typeElement.hasAudioOnLoad) {
      return true;
    }
    var keys = Object.keys((0, _flat["default"])(element));
    return keys.some(function (key) {
      return key.includes('meta.audio');
    });
  });
});
exports.getIsAudioOnLoad = getIsAudioOnLoad;
var getIsPageVisited = (0, _reselect.createSelector)(getPageElements, getAllProgress, function (pageElements, progress) {
  if (pageElements.length === 0) {
    return false;
  }

  // If menu, then check if one of the children is finished
  var firstElement = pageElements[0];
  if (firstElement.type === 'menu' && firstElement.children) {
    return firstElement.children.some(function (childId) {
      return progress[childId] && progress[childId].finishedFirst;
    });
  }
  return Boolean(progress[firstElement.id] && progress[firstElement.id].finishedFirst);
});
exports.getIsPageVisited = getIsPageVisited;
var getIsMobilePageDescriptionVisible = (0, _reselect.createSelector)(getState, getActualPageFirstElementId, getAllProgress, getPlayerTemplate, function (state, actualFirstPageElementId, allProgress, playerTemplate) {
  // user has already seen this page
  if ((0, _get2["default"])(allProgress, "".concat(actualFirstPageElementId, ".finishedFirst"), false)) {
    return false;
  }

  // if page description is different than previous page,we should show it
  var currPageDescription = (0, _get2["default"])(playerTemplate, 'playerTemplateSettings.pageDescription', '');
  if (typeof currPageDescription !== 'string' && currPageDescription.content) {
    currPageDescription = currPageDescription.content;
  }
  var prevPageState = (0, _player["default"])(state, (0, _player.goToPrevPage)());
  var prevPlayerTemplate = getPlayerTemplate(prevPageState);
  var prevPageDescription = (0, _get2["default"])(prevPlayerTemplate, 'playerTemplateSettings.pageDescription', '');
  if (typeof prevPageDescription !== 'string' && prevPageDescription.content) {
    prevPageDescription = prevPageDescription.content;
  }
  return !!currPageDescription && (state.pageFirstElementId === 0 || currPageDescription !== prevPageDescription);
});
exports.getIsMobilePageDescriptionVisible = getIsMobilePageDescriptionVisible;
var getSegmentedProgressBar = (0, _reselect.createSelector)(getScopedList, getAllProgress, getActualPageFirstElementId, getDirections, getAllElements, getPages, function (list, allProgress, actualFirstPageElementId, directions, allElements, pages) {
  var segmentSizeValues = {
    xsmall: 25,
    small: 50,
    normal: 100,
    large: 200,
    xlarge: 400
  };
  var firstElementIds = new Set(pages.map(function (page) {
    return page.firstElementId;
  }));
  var topChildren = list[0].children.filter(function (id) {
    if (list[id].type === 'pageBreak') {
      return false;
    }
    if (!firstElementIds.has(id)) {
      return false;
    }
    var item = list[id];
    if (item.hiddenByConditions) {
      return false;
    }
    return true;
  }).map(function (id) {
    var item = list[id];
    var elementType = (0, _find2["default"])(allElements, {
      code: item.type
    });
    var elementTooltip = (0, _getWysiwygText["default"])(item.settings[elementType.labelField]);
    var duration;
    if (segmentSizeValues[item.settings.segmentSize]) {
      duration = segmentSizeValues[item.settings.segmentSize];
    } else if (item.settings.segmentSize === 'custom' && item.settings.customSegmentSize) {
      duration = parseInt(item.settings.customSegmentSize, 10);
      if (Number.isNaN(duration)) {
        duration = 100;
      }
    } else {
      duration = 100;
    }
    return {
      id: id,
      duration: duration,
      tooltip: item.settings.segmentTooltip || elementTooltip || null,
      progress: 'future'
    };
  });
  var totalDuration = topChildren.reduce(function (sum, item) {
    return sum + item.duration;
  }, 0);
  topChildren.forEach(function (item) {
    item.width = "".concat(Math.round(item.duration * 1000 / totalDuration, 1) / 10, "%");
  });

  // Get current segment
  var topChildrenMap = topChildren.reduce(function (obj, item) {
    obj[item.id] = item;
    return obj;
  }, {});
  var order = directions.filter(function (item) {
    return item.direction === 'in';
  }).map(function (item) {
    return item.id;
  });
  var index = order.indexOf(actualFirstPageElementId);
  for (var i = index; i >= 0; i--) {
    if (topChildrenMap[order[i]]) {
      topChildrenMap[order[i]].isCurrent = true;
      topChildrenMap[order[i]].progress = 'past';
      break;
    }
  }

  // Set progress as "past" for already seen children
  var progressFound = false;
  for (var _i2 = order.length - 1; _i2 >= 0; _i2--) {
    var elementId = order[_i2];
    if (!progressFound && allProgress[elementId]) {
      progressFound = true;
    }
    if (progressFound && topChildrenMap[elementId]) {
      topChildrenMap[elementId].progress = 'past';
    }
  }
  return topChildren;
});
exports.getSegmentedProgressBar = getSegmentedProgressBar;
var getShowBottomBar = (0, _reselect.createSelector)(getPageElements, getAllElements, function (pageElements, allElements) {
  return !pageElements.some(function (element) {
    var elementType = (0, _find2["default"])(allElements, {
      code: element.type
    });
    if (elementType.showBottomBar === false) {
      return true;
    }
    if (typeof elementType.showBottomBar === 'function' && elementType.showBottomBar(element.settings) === false) {
      return true;
    }
    return false;
  });
});
exports.getShowBottomBar = getShowBottomBar;
var getSkippedElements = (0, _reselect.createSelector)(getPageElements, getAllElements, getAnswers, function (pageElements, allElements, answers) {
  return pageElements.filter(function (element) {
    var elementType = (0, _find2["default"])(allElements, {
      code: element.type
    });
    if (typeof elementType.isSkipped !== 'function') {
      return false;
    }
    return elementType.isSkipped({
      settings: element.settings,
      answer: answers[element.id]
    });
  }).map(function (element) {
    return element.id;
  });
});
exports.getSkippedElements = getSkippedElements;
var getIsSkipped = (0, _reselect.createSelector)(getSkippedElements, function (skippedElements) {
  return skippedElements.length > 0;
});
exports.getIsSkipped = getIsSkipped;
var getAllowCancelAudio = (0, _reselect.createSelector)(getPageElements, getAllElements, function (pageElements, allElements) {
  return pageElements.every(function (element) {
    var elementType = (0, _find2["default"])(allElements, {
      code: element.type
    });
    return !elementType.disableCancelAudio;
  });
});
exports.getAllowCancelAudio = getAllowCancelAudio;
var getAllowScaling = (0, _reselect.createSelector)(getPageElements, getAllElements, function (pageElements, allElements) {
  return pageElements.every(function (element) {
    var elementType = (0, _find2["default"])(allElements, {
      code: element.type
    });
    return !elementType.disableScaling;
  });
});
exports.getAllowScaling = getAllowScaling;